import { createApp, ref } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import InstantSearch from 'vue-instantsearch/vue3/es'
import { firebaseApp } from './firebase'
import { VueFire, VueFireAuth } from 'vuefire'
import { initializeCommunityStore } from './stores/Community'
import { createI18n } from 'vue-i18n'
import { useAuthStore } from './stores/Auth'

async function initializeApp() {
  const pinia = createPinia()
  const app = createApp(App)

  app.use(pinia)
  app.use(InstantSearch)
  app.use(VueFire, { firebaseApp, modules: [VueFireAuth()] })

  initializeCommunityStore()

  const appLoading = ref(true)
  app.provide('appLoading', appLoading)

  const authStore = useAuthStore()

  const i18n = createI18n({
    legacy: false,
    locale: 'ko',
    fallbackLocale: 'en',
    messages: {
      ko: { errors: { uploadFailed: '업로드에 실패했습니다.' } },
      en: { errors: { uploadFailed: 'Upload failed.' } },
    },
  })

  try {
    app.use(router)
    await router.isReady()

    app.use(i18n)
    app.mount('#app')

    authStore.initializeAuth().catch((error) => {
      console.warn('Auth initialization failed, but app will continue:', error)
    })

    appLoading.value = false
    console.log('Application initialized successfully')
  } catch (error) {
    console.error('Application initialization failed:', error)
    app.mount('#app')
    appLoading.value = false
  }
}

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

initializeApp().catch((error) => {
  console.error('Critical error during app startup:', error)
})
